export default __webpack_public_path__ + "static/media/logo-scratchpay-text-only-white.87a829fb.png";